import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import FormControl from 'components/atoms/Controls/FormControl/FormControl';
import {rgba} from 'polished';

const StyledFileField = styled(FormControl)`
  outline: none;
  ${props => props.theme.convert2Css(props.theme.property('typography.body1'))}
  
  .FileField {
    &-dropzone {
      display: flex;
      position: relative;
      flex-direction: column;
      padding: ${props => props.theme.spacing(0.75)} ${props => props.theme.spacing(1)};
      border-radius: ${props => props.theme.radius(1)};

      aspect-ratio: 552/148;
      max-height: ${props => props.theme.layout(148)};

      cursor: pointer;
      &.disabled {
        cursor: default;
      }

      input {
        display: none;
      }

      .InputOutline {
        border-style: dashed;
      }
      
      &-inner {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        
        align-items: center;
        justify-content: center;
        gap: ${props => props.theme.layout('1sp')};
        
        .description {
          color: ${props => props.theme.property('palette.text.secondary')};
        }
      }
    }
    
    &-files {
      display: flex;
      flex-direction: column;
    }
    
    &-file {
      display: flex;
      gap: ${props => props.theme.layout('2sp')};
      padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} 0 ${props => props.theme.spacing(2)};
      
      .middle {
        flex-grow: 1;
        display: flex;
        width: 1px;
        flex-direction: column;
        
        .Typography {
          max-width: fit-content;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          overflow: hidden;
        }
        
        .TextField {
          min-width: ${props => props.theme.layout(220)};
          max-width: ${props => props.theme.layout(220)};
        }
        
        .info {
          display: flex;
          gap: ${props => props.theme.layout('0.5sp')};
          color: ${props => props.theme.property('palette.text.secondary')};
          
          .split {
            transform: translateY(-20%);
          }
        }
        
        .LinearProgress {
          margin: ${props => props.theme.spacing(0.5)} 0;
          max-width: ${props => props.theme.layout(220)};
        }
      }
      
      .button {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        padding: ${props => props.theme.spacing(0.25)};
        
        .IconButton {
          color: ${props => props.theme.property('palette.action.active')};
          
          ${props => props.theme.state2Selector('IconButton', null, ['hover', 'focus', 'focusVisible'])} {
            svg {
              color: ${props => props.theme.property('palette.text.primary')};
            }
          }
        }
      }
    }
  }
  
  &.FileField-fullWidth {
    width: 100%;
  }

  &:not(.FileField-disabled) .InputContainer:hover {
    .InputOutline {
      border-color: ${props => props.theme.property('palette.input.outlined.hoverBorder')};
    }
  }
  
  &:not(.FileField-disabled).FileField-focused {
    .InputOutline {
      border-color: ${props => props.theme.property('palette.primary.main')};
      background-color: ${props => props.theme.property('palette.primary.states.selected')};
      border-width: 2px;
    }
  }

  &:not(.FileField-disabled).FileField-error {
    .InputOutline {
      border-color: ${props => props.theme.property('palette.error.main')};
      background-color: ${props => props.theme.property('palette.error.states.hover')};
    }
  }
  
  &.FileField-disabled {
    color: ${props => props.theme.property('palette.text.disabled')};

    .Avatar {
      svg {
        color: ${props => props.theme.property('palette.text.disabled')} !important;
      }
    }
    
    .description {
      color: ${props => props.theme.property('palette.text.disabled')} !important;
    }

    .FileField-dropzone {
      background-color: ${props => rgba(props.theme.property('palette.action.disabledBackground'), 0.01)} !important;
    }
    
    .FileField-file {
      .info {
        color: ${props => props.theme.property('palette.text.disabled')} !important;

        > * {
          color: ${props => props.theme.property('palette.text.disabled')} !important;
        }
      }
    }
  }
  
  // File variant
  &.FileField-fileVariant-logo {
    .FileField {
      &-dropzone {
        overflow: hidden;
        border-radius: 50%;
        aspect-ratio: 1;
        max-height: unset;
        width: 100%;
        margin: 0;
        
        &-inner {
          .logo {
            width: 100%;
            height: 100%;
          }

          .CircularProgress {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: ${props => rgba(props.theme.property('palette.action.disabled'), 0.2)};
            
            .CircularProgress {
              width: max(min(${props => props.theme.layout(40)}, 100%), 32%) !important;
              height: max(min(${props => props.theme.layout(40)}, 100%), 32%) !important;
              background-color: transparent;
            }
          }
        }
      }

      &-delete {
        position: absolute;
        top: 0; 
        right: 0;
        width: fit-content;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledFileField.propTypes = {
  theme: PropTypes.object
};

export default StyledFileField;
